import { render, staticRenderFns } from "./AuditLogsView.vue?vue&type=template&id=4f655c80&scoped=true&"
import script from "./AuditLogsView.vue?vue&type=script&lang=js&"
export * from "./AuditLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f655c80",
  null
  
)

export default component.exports